import { fadeUp, staggerContainer } from '@/core/constants/animations'
import { cn } from '@/core/lib/utils/cn'
import { Motion } from '@/core/ui/atoms/motion'
import { getTranslations } from 'next-intl/server'

interface Props {
  className?: string
}

export const WhereWeOperate = async ({ className }: Props) => {
  const t = await getTranslations()

  const paragraphs = [
    t('about.presence'),
    t('about.morningOrNight'),
    t('about.committed'),
    t('about.everyFlight'),
  ]

  return (
    <Motion
      type='section'
      className={cn('sm:mb-12', className)}
      aria-label={t('ariaLabels.whereWeOperate')}
      variants={staggerContainer}
      initial='initial'
      whileInView='animate'
      viewport={{ once: true, amount: 0.4 }}
    >
      {paragraphs.map((text, i) => (
        <Motion
          type='p'
          key={i}
          className='mb-6'
          variants={fadeUp.variants}
          transition={fadeUp.transition}
        >
          {text}
        </Motion>
      ))}
    </Motion>
  )
}
